import { tss } from 'tss-react/mui';

const useStyles = tss
  .withParams<{
    areRulesDetailsExpanded: boolean;
  }>()
  .create(({ theme, areRulesDetailsExpanded }) => ({
    administrationRules: {
      display: 'grid',
      gridTemplateRows: areRulesDetailsExpanded ? '1fr 0.5fr' : 'auto',
      height: '100%',
      rowGap: '1.5rem',
      [theme.breakpoints.up('md')]: {
        columnGap: '1.5rem',
        gridTemplateColumns: areRulesDetailsExpanded ? '1fr 250px' : '1fr',
        gridTemplateRows: '1fr',
        rowGap: 0
      },
      [theme.breakpoints.up('lg')]: {
        gridTemplateColumns: areRulesDetailsExpanded ? '1fr 350px' : '1fr'
      },
      [theme.breakpoints.up('xl')]: {
        gridTemplateColumns: areRulesDetailsExpanded ? '1fr 450px' : '1fr'
      }
    },
    administrationRulesWrapperBox: {
      height: '100%',
      overflowX: 'auto'
    },
    administrationRulesPaper: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      overflow: 'hidden'
    },
    administrationRulesSearchBox: {
      backgroundColor: 'var(--mui-palette-background-elevation1)',
      padding: '0.5rem 1rem',
      borderBottom: 'solid 1px var(--mui-palette-border-light)',
      '.quickSearch': {
        maxWidth: '20rem'
      }
    }
  }));

export default useStyles;
